var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"appMain",staticClass:"app-main"},[[_c('keep-alive',[(_vm.$route.meta.keepAlive )?_c('router-view',{key:_vm.key,ref:"pagemain"}):_vm._e()],1),(!_vm.$route.meta.keepAlive )?_c('router-view'):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }